import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=7efc3308&scoped=true"
import script from "./CreateCompany.vue?vue&type=script&lang=js"
export * from "./CreateCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efc3308",
  null
  
)

export default component.exports